<script setup lang="ts">
import { computed } from "vue";

import { useAircraftClass } from "@/composables/aircraft";
import {
	useAircraftFlights, useAircraftFlightsProcessing, useAircraftStats,
} from "@/queries/aircraft";

import FlightListItem from "./FlightListItem.vue";
import FlightListItemRotorwing from "./FlightListItemRotorwing.vue";

const props = defineProps<{
	aircraftId: string;
}>();
const {
	data: flights, isLoading, 
} = useAircraftFlights(() => props.aircraftId);

const aircraftClass = useAircraftClass();
const { data: stats } = useAircraftStats(() => props.aircraftId);
const landingThreshold = computed(() => stats.value?.shortStripLandings.landingThreshold ?? 4000);
const shortStripLandingsIds = computed(() => stats.value?.shortStripLandings.flightIds ?? []);
const lateNightFlightsIds = computed(() => stats.value?.lateNightFlights.flights ?? []);

const { data: processing } = useAircraftFlightsProcessing(() => props.aircraftId);
const buckets = computed(() => processing.value?.buckets ?? {});
</script>

<template>
  <section>
    <ul
      class="flex flex-col gap-4"
    >
      <li
        v-for="flight in flights"
        :key="flight.id"
      >
        <FlightListItemRotorwing
          v-if="aircraftClass === 'Rotor-wing'"
          :flight="flight"
          :bucket="buckets[flight.id]"
          :landing-threshold="landingThreshold"
          :short-strip-landings-ids="shortStripLandingsIds"
          :late-night-flights-ids="lateNightFlightsIds"
        />
        <FlightListItem
          v-else
          :flight="flight"
          :bucket="buckets[flight.id]"
          :landing-threshold="landingThreshold"
          :short-strip-landings-ids="shortStripLandingsIds"
          :late-night-flights-ids="lateNightFlightsIds"
        />
      </li>
    </ul>
    <UCard
      v-if="!isLoading && flights?.length === 0"
      variant="subtle"
    >
      <p class="text-center">
        No flights in this period
      </p>
    </UCard>
  </section>
</template>
